import classNames from "classnames";
import { FC } from "react";
import styles from "./State.module.css";

type StateProps = {
  text: string;
  color: "blue" | "red" | "green" | "orange" | "yellow";
};

export const State: FC<StateProps> = ({ text, color }: StateProps) => {
  return (
    <div
      className={classNames(styles.state, {
        [styles.green]: color === "green",
        [styles.red]: color === "red",
        [styles.blue]: color === "blue",
        [styles.yellow]: color === "yellow",
        [styles.orange]: color === "orange",
      })}
    >
      {text}
    </div>
  );
};
